<ras-page>
	<main>
		<h1>Frequently asked questions</h1>

		<p class="lead">We maintain this detailed list of questions and answers with links to additional information, based on questions our customers commonly ask.</p>

		<nav>
			<ul>
				<li><a routerLink="./" fragment="about">About self storage</a></li>
				<li><a routerLink="./" fragment="started">Getting started</a></li>
				<li><a routerLink="./" fragment="rental">Rental period</a></li>
				<li><a routerLink="./" fragment="moving">Moving in</a></li>
				<li><a routerLink="./" fragment="access">Access</a></li>
				<li><a routerLink="./" fragment="security">Security and insurance</a></li>
				<li><a routerLink="./" fragment="paying">Paying your rent</a></li>
				<li><a routerLink="./" fragment="transport">Transport</a></li>
				<li><a routerLink="./" fragment="packing">Packing supplies</a></li>
			</ul>
		</nav>

		<h2 id="about">About self storage</h2>

		<h3>What is self-storage?</h3>
		<p>Self storage allows you to rent storage space on a month-to-month basis at affordable rates in a secure environment, using your own lock and key. It’s a simple, accessible, convenient and private way to store goods. You can choose to store more or less anything you like in the space size that you choose for as long a time as necessary. Unlike traditional storage methods, self storage allows you to access your storage space free of charge at any time (subject to facility opening times).</p>

		<h3>What can I store?</h3>
		<p>You can store practically anything from personal and household goods to business items, including vehicles, trailers, office furniture, documents, excess stock, promotional items, tools and equipment.</p>

		<h3>Who uses self storage?</h3>
		<p>Home owners, business owners, students, government organisations and individuals on the move, relocating or building a house.</p>

		<h3>When can I access my storage unit?</h3>
		<p>Gate hours are strictly from 6am to 6pm, 365 days a year. No exceptions can be made this for the sake of your absolute security.</p>

		<h3>When are the facility offices open?</h3>
		<p>Monday to Friday, from 8am to 5pm, and every Saturday from 9h00 to 13h00. Offices are closed on public holidays.</p>


		<h2 id="started">Getting started</h2>

		<h3>How do I get started?</h3>
		<p>Select a RENT-A-STORE facility that’s conveniently situated to your home or business. We would love it if you visited us in person or you can just simply click on GET A QUOTE.  Here you can access unit size estimators and the related prices at our various locations. You can also temporarily reserve your unit at no charge. Then when you are ready to commit to the rental you can move-in online by e-signing of the lease agreement and making payment of your first months rent. Or if you prefer the personal touch call us on 0861 73 68 27 for information or to rent a unit. Before you proceed, we do suggest that you look at our <a [routerLink]="['/moving-tips']">Packing and Moving Tips</a> as well as FAQ which will give you a very good idea of how self-storage at RENT-A-STORE works.</p>

		<h3>What unit sizes do you have?</h3>
		<p>We offer a variety of sizes at our various facilities ranging from 1sqm to 54sqm.</p>

		<h3>Do I need to make an appointment to view your storage facilities?</h3>
		<p>You are welcome to visit any of our storage sites any time during office hours. An appointment is not necessary, but we recommend that you make one to ensure that a storage manager is available to show you the facilities and answer your questions.</p>

		<h3>How do I book my storage space?</h3>
		<p>The easiest way is to click on <b>Reserve your unit</b>, here you will be able to reserve a unit at no charge and or rent a unit immediately.  Or, contact our offices by telephone 0861 73 68 27. Once you have completed the online rental process in +- 15 min, you will receive a once off access pass that allows you to immediately access your unit. </p>

		<h3>What documentation is required?</h3>
		<p>Different documents are required depending on the entity renting the storage unit. But for private individuals, a copy of your South African ID or driver’s license will be all that is required.</p>

		<h3>How far in advance can I rent a storage unit?</h3>
		<p>To assist you in planning ahead for your intended move and to avoid disappointment you can rent your unit up to 30 days prior to the day of your intended occupation.</p>
		<p>Advance booking also helps make it possible for you to secure <a [routerLink]="['/free-move-in-transport']">free move in transport</a> for the time that suits you best.</p>


		<h2 id="rental">Rental period</h2>

		<h3>Is a lease agreement required?</h3>
		<p>Yes. Before you move into a self storage unit you are required to sign the Rent-A-Store <a href="{{environment.webBaseUrl}}/booking.aspx?link=proforma_agreements" target="_blank">lease agreement</a> in which all terms and conditions of tenancy are clearly outlined. If you choose to rent a unit online the quick and easy e-sign option is available. <a href="{{environment.webBaseUrl}}/booking.aspx?link=proforma_agreements" target="_blank">Download terms and conditions.</a></p>

		<h3>How long is the lease period?</h3>
		<p>No long-term commitments are required as our rental contract is on a month to month basis.</p>

		<h3>What is the minimum time I can store my goods for?</h3>
		<p>The minimum rental period is one full calendar month.</p>

		<h3>What is the maximum time I can store my goods for?</h3>
		<p>There is no limit and your agreement is extended automatically each month until you issue one full calendar month’s written notice to vacate your storage unit.</p>

		<h3>What if I want to move in from a date which is not exactly the end of the month?</h3>
		<p>Should you require to move in before the commencement of the next full calendar month you will be required to pay a prorated charge as well as the next full month’s rent on signing the lease.</p>

		<h3>What if I want to move out on a date that is not exactly the end of the month?</h3>
		<p>If you decide to move out a few days earlier than the last day of the month, you will still be charged for the full calendar month. The last month of your stay is always a full calendar month. No Pro Rata deductions are made on moving out.</p>

		<h3>How do I terminate my lease agreement?</h3>
		<p>You can terminate the agreement by issuing us with written notice of one full calendar month.</p>


		<h2 id="moving">Moving in</h2>

		<h3>What is a once off access pass?</h3>
		<p>If you rented online you will receive a once off access pass for you and your additional access persons for your initial move-in.</p>

		<h3>When can I move in?</h3>
		<p>You can move in on or after your occupation date and only once all your <a href="{{environment.webBaseUrl}}/booking.aspx?link=proforma_agreements">lease documentation</a> has been received and payment is made in full, will you be granted access. Should you complete the rental online, you can move in immediately using your once off access pass.</p>

		<h3>How do I lock my storage unit?</h3>
		<p>Secure your storage unit with a padlock. Padlocks can be purchased from our Packing Supplies shops located at our facilities during office hours.</p>

		<h3>What size padlock should I purchase?</h3>
		<p>The unique tamper proof padbolt can accommodate locking bars up to 10mm in diameter.</p>

		<h3>Do you have trolleys to assist me to move my goods into storage?</h3>
		<p>Yes. We have trolleys available on site to help you move heavier items into your storage space.</p>

		<h3>How should I prepare my goods for storage?</h3>
		<p>We provide comprehensive guidelines on our <a [routerLink]="['/moving-tips']">Packing and Moving Tips</a> page. Look at our Packing Supplies page for packing items you may need to prepare your goods for storage. These can be purchased from our Packing Supplies stores located at our storage facilities.</p>

		<h3>What is the best way to pack a self storage space?</h3>
		<p>There are some simple practices that can help you optimise the use of your storage space. For useful guidelines visit our <a [routerLink]="['/moving-tips']">Packing and Moving Tips page</a>.</p>


		<h2 id="access">Access</h2>

		<h3>Can I drive right up to my unit?</h3>
		<p>You can drive right up to and park outside all “drive up to” units. “Inside access” units are accessed via elevators and generous passages.</p>

		<h3>Can access to the premises after hours be arranged?</h3>
		<p>No. External lock out security procedures do not allow any after hours exceptions, this for your personal safety and that of your goods. Gates are locked out and premises are monitored off site.</p>

		<h3>How often and when can I access my unit?</h3>
		<p>You can access your storage space as frequently as you like within the stipulated gate hours.</p>

		<h3>Can I bring helpers with me to assist with my move in or at other times when I require assistance?</h3>
		<p>Yes, however persons who have not registered may not access the premises or be left unaccompanied. You or one of your registered users must be in attendance at all times.</p>

		<h3>Are the premises gates access controlled?</h3>
		<p>Absolutely, You will be required to verify your identity and communicate particulars via intercom on every visit. Exact details of when, how and with whom you entered will be recorded.</p>

		<h3>Can a friend, relative or colleague have access to my unit?</h3>
		<p>Yes. You can add up to five individuals to your access list.</p>


		<h2 id="security">Security and insurance</h2>

		<h3>Is Rent-A-Store a high security facility?</h3>
		<p>Yes you will experience total peace of mind. State-of-the-art security systems are installed at all our sites, and we enforce strict standards to maintain a secure environment. Refer to our Security page for detailed information.</p>

		<h3>Do I need to take out insurance?</h3>
		<p>Although Rent-A-Store provides a high security environment, you are ultimately responsible for the goods you are storing at Rent-A-Store and insurance for your stored belongings is advised. You may be covered under an insurance policy you already have. Check with your insurance agent to be sure.</p>


		<h2 id="paying">Paying your rent</h2>

		<h3>When is my rent due?</h3>
		<p>Rent is due in advance on the first day of each month. Your first instalment is due when your unit is booked. Thereafter rental will be automatically paid by debit order from your account on the first or second working day of the month.</p>

		<h3>Will I receive a monthly VAT invoice?</h3>
		<p>A copy of your storage <a href="{{environment.webBaseUrl}}/booking.aspx?link=proforma_agreements" target="_blank">lease agreement</a> together with your proof of payment serves as a valid VAT invoice for SARS purposes. We do not issue invoices monthly.</p>

		<h3>Which methods of payment do you accept?</h3>
		<p>When renting on-line, your first month’s rent payment is paid via credit card (VISA or MasterCard). When renting via email or in-store you can swipe your credit card, use snap scan or Zapper or you can make an EFT or direct deposit into our bank account. For security reasons we can not accept  accept cash or cheques.</p>
		<p>Thereafter, monthly rentals are strictly payable by debit order.</p>

		<h3>Do you accept Diners Club and American Express?</h3>
		<p>No. We only accept VISA or MasterCard.</p>

		<h3>Is the rental inclusive or exclusive of VAT?</h3>
		<p>The price quoted will always be inclusive of VAT.</p>

		<h3>Are there any other initial costs such as a deposit involved?</h3>
		<p>We do not require a deposit or charge any other administrative costs when moving in.</p>


		<h2 id="transport">Transport</h2>

		<h3>What is free move in transport?</h3>
		<p>Free move in transport is the free use of either a Rent-A-Store truck or trailer for your initial move in to a Rent-A-Store storage unit. You are eligible for the use of a truck and driver or trailer based your proximity from a RENT-A-STORE branch on the unit type which you lease, and availability of transport on the day you wish to move in. <a [routerLink]="['/free-move-in-transport']">Read more about free move in transport</a>.</p>


		<h2 id="packing">Packing supplies</h2>

		<h3>Do you sell boxes and packing materials?</h3>
		<p>Yes. For your convenience, we stock a wide range of boxes, packing wraps, mattress and couch covers as well as pictures corners, rope, tape and other accessories to assist you with moving and storing your valuables. These can be purchased at Packing Supplies shops at our site locations.</p>
	</main>
</ras-page>
